import {computed,ref,watch} from 'vue'
import {defineStore} from 'pinia'
import {useQuery,useQueryClient} from '@tanstack/vue-query'
import {useAuthStore} from './auth'
import {assignmentNotificationsAPI} from '@/api/assignmentNotifications'
export const useAssignmentNotificationsStore=defineStore('assignmentNotifications',()=>{
 const auth=useAuthStore(),client=useQueryClient()
 const identity=computed(()=>String(auth.user?.details?.id || auth.user?.id || ''))
 const key=computed(()=>['assignmentNotifications',identity.value])
 const busy=ref(false)
 const query=useQuery({queryKey:key,enabled:computed(()=>!!auth.token && !!identity.value),queryFn:async({signal})=>{
  const owner=identity.value
  return {owner,...await assignmentNotificationsAPI.load(signal)}
 },refetchInterval:30000,refetchOnWindowFocus:true,refetchOnReconnect:true,retry:1})
 const notifications=computed(()=>query.data.value?.owner===identity.value && Array.isArray(query.data.value.notifications) ? query.data.value.notifications : [])
 watch(identity,(_owner,previous)=>{if(previous){void client.cancelQueries({queryKey:['assignmentNotifications',previous]});client.removeQueries({queryKey:['assignmentNotifications',previous]})}})
 watch(()=>auth.token,()=>{void client.invalidateQueries({queryKey:['assignmentNotifications']})})
 async function dismiss(id:string) {
  const owner=identity.value
  busy.value=true
  try{await assignmentNotificationsAPI.dismiss(id);if(owner===identity.value) await query.refetch()}
  finally{busy.value=false}
 }
 return {identity,notifications,busy,refresh:query.refetch,dismiss,invalidate:()=>client.invalidateQueries({queryKey:key.value})}
})
